import { IMAGE_DESKTOP, IMAGE_MOBILE } from '../elements/assets'

export const AGENDA_GROUPED = `
...on agendaGrouped_Entry {
  id
  typeHandle
  anchorId
  backgroundColor

  heading: headingAdvanced {
    html
  }

  slots: agendaGroupedSlots {
    id
    label
    agendaLabelColor
    time: title
    ${ IMAGE_DESKTOP }
    ${ IMAGE_MOBILE }

    sessions: agendaGroupedSessions {
      id
      title
      description
      tags {
        id
        title
      }
      iconField { url }
      attribution
      iconField2 { url }
      attribution2
    }
  }
}
`